var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVisitanteGrayscale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.22,
    height: 18.801,
    viewBox: "0 0 12.22 18.801",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-visitante-grayscale",
    d: "M11.61,2A2.82,2.82,0,1,1,8.79,4.82,2.82,2.82,0,0,1,11.61,2m0,6.58a9.188,9.188,0,0,1,4.23.987c1.26.667,1.88,1.466,1.88,2.406V17.4c0,1.053-.808,1.936-2.454,2.642V17.981c0-.893-.808-1.523-2.425-1.908a5.8,5.8,0,0,0-1.231-.179,5.488,5.488,0,0,0-2.312.489A2.08,2.08,0,0,0,8,17.614a9.821,9.821,0,0,0,3.61.752l.94-.094v2.472l-.94.056a9.1,9.1,0,0,1-3.657-.761C6.308,19.334,5.5,18.451,5.5,17.4V11.974c0-.94.62-1.739,1.88-2.406a9.216,9.216,0,0,1,4.23-.987m0,1.88a1.88,1.88,0,1,0,1.88,1.88A1.88,1.88,0,0,0,11.61,10.46Z",
    transform: "translate(-5.5 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisitanteGrayscale);
export default __webpack_public_path__ + "static/media/icon-visitante-grayscale.c913f25716622d7184b88746585ce0cb.svg";
export { ForwardRef as ReactComponent };